import React, { useContext } from 'react';
import styled from 'styled-components';

import CloseIcon from '@components/icons/close/close';
import FilterIcon from '@components/icons/filter/filter';

import { getColor, mq } from '@stylesheets/tools';

import { Context } from '../../../context/provider';

const StyledFilterFloatingButton = styled.button`
  cursor: pointer;
  position: relative;
  border: 2px solid ${getColor('black')};
  border-radius: 3px;
  width: min-content;
  display: flex;
  justify-content: center;
  align-items: center;
  background: ${props => getColor(props.$open ? 'black' : 'white')};
  color: ${props => getColor(props.$open ? 'white' : 'black')};
  width: 50px;
  height: 50px;

  ${mq('l')} {
    display: none;
  }

  svg {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
`;

const FilterFloatingButton = () => {
  const { filter, setIsModalOpen } = useContext(Context);

  const onButtonClick = () => {
    setIsModalOpen(!filter.isModalOpen);
  };

  return (
    <StyledFilterFloatingButton $open={filter.isModalOpen} type="button" onClick={onButtonClick}>
      {!filter.isModalOpen ? <FilterIcon /> : <CloseIcon />}
    </StyledFilterFloatingButton>
  );
};

export default FilterFloatingButton;
